const keyMap = {}

for (let i = 2; i <= 4; i++) {
  const mainKey = `${i}D`
  const groupKey = ''
  keyMap[`${i}:MULTI:ORDER:TAIL`] = {
    mainKey,
    supKey: 'vi_tail',
    groupKey
  }

  keyMap[`${i}:MULTI:ORDER:MATCH`] = {
    mainKey,
    supKey: 'get_group',
    groupKey
  }

  if (i < 4) {
    keyMap[`${i}:MULTI:ORDER:HEAD`] = {
      mainKey,
      supKey: 'vi_head',
      groupKey
    }

    keyMap[`${i}:MULTI:ORDER:HEAD:TAIL`] = {
      mainKey,
      supKey: 'head_tail',
      groupKey
    }

    keyMap[`${i}:MULTI:ORDER:MATCH:7`] = {
      mainKey,
      supKey: 'get_group_7',
      groupKey
    }
  }
}

export default keyMap
